import Controller from "@sabyr-dev/mist_core/controller";
import {
	Attempt, Product, Question, Quiz
} from "@sabyr-dev/mist_elibrary/datasource";
import { InitializeEvent } from "@sabyr-dev/mist_core/events";
import { AcademyApp } from "../app";

export class ReviewInitController extends Controller<Product, Attempt, Quiz, Question> {
	bind(target: EventTarget, app: AcademyApp): void {
		target.addEventListener(InitializeEvent.type, () => this.initialize(app));
	}

	async initialize(app: AcademyApp): Promise<void> {
		const listModel = app.model.list;
		const list = await listModel.getItemList();
		const indices = await app.model.list.getItemIndexMap();
		const times = app.timer.serializeTimes(indices);
		for (const item of list) {
			if (item.answer) {
				app.view.list.displayQuestionResult(item.id, item.status, times[item.id]);
			}
		}
		const [scores, total] = await Promise.all([
			app.model.score.getReviewScores(),
			app.model.score.getTotalScores()
		]);
		app.view.scores.displayReviewScoreTable(scores, total);
	}
}
